import { SharingActionTypes } from './types';

export interface SharingState {
  loading: boolean;
  friendEmails: string[];
}

export const initialShareState: SharingState = {
  loading: false,
  friendEmails: [],
};

export function sharingReducer(state = initialShareState, action: SharingActionTypes): SharingState {
  switch (action.type) {
    case 'SHARE_RESULTS_REQUESTED': {
      return { ...state, loading: true };
    }
    case 'SHARE_RESULTS_SUCCEEDED':
      return { ...state, ...action.payload, loading: false };
    case 'SHARE_RESULTS_FAILED': {
      return { ...state, loading: false };
    }
    default:
      return state;
  }
}
